<!-- src/components/CustomMachineSelect.vue -->
<template>
  <div class="select-wrap">

    <div
      class="select-box"
      :class="{ disabled: disabled }"
      @click="toggleDropdown"
    >
      <p v-if="!selectedOption">{{ $t('選択してください') }}</p>
      <div v-else class="selected-items">
        <img :src="resolveImgPath(selectedOption.img)" alt="shopbot">
        <p>
          <span>{{ selectedOption.name }}</span><br/> {{ selectedOption.bedWidth }} x {{ selectedOption.bedDepth }}
        </p>
      </div>
      <i v-html="svg.caret" class="h-44"></i>
    </div>

    <ul v-if="isOpen" class="options">
      <li
        v-for="machine in machines"
        :key="machine.id"
        @click="selectOption(machine)"
        :class="{ selected: machine.id === selectedValue }"
      >
        <img :src="resolveImgPath(machine.img)" alt="shopbot">
        <p>
          <span>{{ machine.name }}</span><br/> {{ machine.bedWidth }} x {{ machine.bedDepth }}
        </p>
      </li>
    </ul>

  </div>
</template>

<script>
import svgSelectBoxCaret from '@/assets/images/plugin/select_box_caret44.svg';
export default {
  name: 'CustomSelect',
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    machines: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      selectedValue: this.value,
      svg: {
        caret: svgSelectBoxCaret
      }
    };
  },
  computed: {
    selectedOption() {
      return this.machines.find(machine => machine.id === this.selectedValue);
    }
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },
    selectOption(machine) {
      this.selectedValue = machine.id;
      this.$emit('input', this.selectedValue);
      this.isOpen = false;
    },
    resolveImgPath(img) {
      return require(`@/assets/images/${img}`);
    }
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    }
  }
};
</script>

<style scoped>
.select-wrap {
  position:relative;
  cursor: pointer;
}
.select-box{
  display:flex;
  justify-content: space-between;
  align-items: center;
  color:#35383B;
  width: 100%;
  height: 44px;
  outline: none;
  border: none;
  border-radius: 3px;
  padding: 0 0 0 8px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: #fff;

  &.disabled{
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.selected-items{
  display:flex;
  flex-direction: row;
  justify-content: flex-start;
  gap:8px;
  align-items: center;
  img{
    width: 44px;
    height: 44px;
  }
  p{
    span{
      font-size: 10px;
    }
    font-size: 14px;
  }
}

.options {
  position: absolute;
  top:105%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  z-index: 100;
  color:#35383B;
  border-radius: 3px;
  overflow: hidden;
}
.options>li {
  cursor: pointer;
  list-style: none;
  margin:0!important;
  display:flex;
  flex-direction: row;
  justify-content: flex-start;
  gap:8px;
  align-items: center;
  padding: 0 0 0 8px;
  img{
    width: 44px;
    height: 44px;
  }
  p{
    span{
      font-size: 10px;
    }
    font-size: 14px;
  }
}
.options li:hover,
.options li.selected {
  background-color: #f0f0f0;
}
i.h-44{
  height:44px!important;
  svg{
    height: 44px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomMachineSelect.vue